import React, { useContext } from 'react';
import { format } from 'date-fns';
import { trackClickEventProp54 } from '../../utils/omnitureUtils';
import RouteInfoContext from '../route_info/RouteInfoContext';
import '../../styles/busListing.css';

type BusListingType = {
  onClose: () => void;
};

const BusListing = ({ onClose }: BusListingType) => {
  const trainsData = useContext(RouteInfoContext);
  const { fromCity, toCity } = trainsData;

  const busData = trainsData?.busSeoRoutes?.busGroups
    ?.find((busGroup) => busGroup.groupName === 'Private Buses')
    ?.buses?.splice(0, 10);
  const srcCode = trainsData?.busSeoRoutes?.sourceCityCode;
  const destCode = trainsData?.busSeoRoutes?.destinationCityCode;

  const modalHeight = (window.innerHeight * 80) / 100;
  const facilities = [
    { name: 'Live Tracking', class: 'trackingIc' }
    // { name: 'Free Date Change', class: 'dateChangeIc' }
  ];

  const handleBusLink = (doj, mwebUrl) => {
    trackClickEventProp54('trains_seo_route_cp_bus_selected');
    const validMwebUrl = mwebUrl
      ? mwebUrl.replace('deptDate', doj)
      : `https://www.makemytrip.com/mbus/rnw/busListingPage?from=${fromCity}&from_code=${srcCode}&to=${toCity}&to_code=${destCode}&departure=${doj}&sort=Rating&skipCache=true`;
    window.location.href = validMwebUrl;
  };

  const redirectToBus = (completeDate = '', mwebUrl = '') => {
    const date = new Date();
    const validDoj = format(date, 'dd-MM-yyyy');
    handleBusLink(completeDate ? completeDate : validDoj, mwebUrl);
  };

  return (
    <div className="modalWrapper" style={{ height: modalHeight }}>
      <div className="busModalHeader">
        <span>
          {fromCity} to {toCity} Buses
        </span>
        <div onClick={onClose} className="closeIc" />
      </div>
      <div className="busModalListing">
        {busData.map((item, index) => {
          const {
            operatorName,
            busType,
            departureTimeStr,
            durationInMins,
            arrivalTimeStr,
            availableSeats,
            avlWindowSeats,
            rating,
            noOfRatings,
            minFare,
            mwebUrl
            // doj
          } = item;

          const hours = Math.floor(durationInMins / 60);
          const mins = durationInMins % 60;

          return (
            <div className="busInfoCard" onClick={() => redirectToBus('', mwebUrl)} key={index}>
              <div className="busInfoTop">
                <div className="busInfolLeft">
                  <div className="busInfoTitleWrapper">
                    <p className="busName">{operatorName}</p>
                    {/* primo support to be added later /*}
                    {/* <div className="primoSection" /> */}
                  </div>
                  <p className="busType">{busType}</p>
                  <p className="busJourneyDetail">
                    <span className="busTiming">{departureTimeStr} </span>
                    <span className="journeySeperator">-</span>{' '}
                    <span className="busDuration">
                      {hours} hr {mins} mins
                    </span>{' '}
                    <span className="journeySeperator">-</span> <span className="busTiming">{arrivalTimeStr}</span>{' '}
                    {/* <span className="busJourneyDays">+1 day</span> */}
                  </p>
                  <div className="busSeatsNo">
                    {!!availableSeats && (
                      <div className="busSeat">
                        <span>{availableSeats} Seats Left</span>
                      </div>
                    )}
                    {!!avlWindowSeats && (
                      <div className="busSeat">
                        <span>{avlWindowSeats} Window Seats</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="busInfoRight">
                  <div className="ratingWrapper">
                    <div className="starIc" />
                    <span className="ratingTxt">{rating}</span>
                  </div>
                  <p className="totalRatingTxt">{noOfRatings} ratings</p>
                  <p className="ratingRs">₹{minFare}</p>
                  {/* <p className="ratingDiscRs">₹1700</p> */}
                </div>
              </div>
              <div className="busInfoBottom">
                {facilities.map((facility, i) => {
                  return (
                    <div className="busFacility" key={'busFacilities' + i}>
                      <div className={`busFacilityIc ${facility.class}`} />
                      <span>{facility.name}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        <p className="makeFlex perfectCenter appendBottom20" onClick={() => redirectToBus()}>
          <div className="bluePrimarybtn moreBus">View More buses</div>
        </p>
      </div>
    </div>
  );
};

export default BusListing;
